import { theme } from '../modules/ddk/explorer/theme'
const poi_data = require('./poi_data.json')
import _ from 'lodash'

// Base URL for the map app
export const BASE_URL = 'https://diversitydatakids.org/map/'
export const PARENT_SITE = 'https://diversitydatakids.org/'
export const FB_APP_ID = '527190134911454'

// Routing
export const ROUTE_GEO = 'activeGeo' // Geo type, 'tracts', 'zips', 'counties'
export const ROUTE_VIEW = 'activeView' // View type, 'explorer' or 'embed'
export const ROUTE_ACTIVE_SHAPE = 'activeShape' // ID of active (clicked) shape on map (tract/zip)
export const ROUTE_ACTIVE_YEAR = 'activeYear' // 2010 or 2015
export const ROUTE_LOAD_YEARS = 'loadYears' // Comma-delineated list of years of data to load.
export const ROUTE_ACTIVE_POINTS = 'activePointLayers' // Comma-delineated list of active dot density layers
export const ROUTE_RATING_TYPE = 'activeRatingType' // 'x' or 's' (levels or scores)
export const ROUTE_METRIC = 'activeMetric' // coi vs one of the domains
export const ROUTE_NORM = 'activeNorm' // whether data is normalized by metro (m) or nation (n) or state (s)
export const ROUTE_LAT = 'lat' // Latitude
export const ROUTE_LNG = 'lng' // Longitude
export const ROUTE_ZOOM = 'zoom' // Zoom level
export const ROUTE_ACTIVE_REDLINING = 'activeRedliningTypes' // Comma-delineated list of active redlining grade overlays

// reflects that points are split between 2 layers
export const POINT_LAYERS = [1, 2]

export const COI_METRIC = 'c'
// x: levels, s: scores
export const RATING_TYPES = ['x', 's']
export const GEO_TYPES = ['tracts', 'zips', 'counties']
const NORM_TYPES = ['n', 's', 'm']

// acceptable 'view' values in wkkf mode
const poiOptions = poi_data.sites.map(s => 'wkkf' + s.id)

// DEFAULTS
export const DEFAULT_GEO = GEO_TYPES[0]
export const DEFAULT_VIEW = 'explorer'
export const DEFAULT_ACTIVE_SHAPE = 0
export const DEFAULT_LOAD_YEARS = ['12', '18', '24']
export const DEFAULT_ACTIVE_YEAR = DEFAULT_LOAD_YEARS.slice(
  -1,
)[0]
export const DEFAULT_ACTIVE_POINTS = [
  'ai',
  'ap',
  'b',
  'hi',
  'w',
]
export const DEFAULT_RATING_TYPE = RATING_TYPES[0]
export const DEFAULT_METRIC = COI_METRIC
export const DEFAULT_NORM = 'n'
export const DEFAULT_DATA_VERSION = '6.0.1'
export const DEFAULT_LAT = '40.364' // '37.39'
export const DEFAULT_LNG = '-96.128' // '-96.78'
export const DEFAULT_ZOOM = '4' // '3.15'
export const DEFAULT_ACTIVE_REDLINING = []

// OPTIONS

// NOTE: include '' if empty route value is acceptable
export const OPTIONS_VIEW = {
  options: ['explorer', 'embed', 'wkkf', ...poiOptions],
  validate: 'one_exact_match', // Provided value must exactly match one of these.
}
export const OPTIONS_GEO = {
  options: GEO_TYPES,
  validate: 'one_exact_match', // Provided value must exactly match one of these.
}
export const OPTIONS_ACTIVE_SHAPE = {
  options: '',
  validate: 'type_number', // Any number.
}
export const OPTIONS_ACTIVE_YEAR = {
  options: DEFAULT_LOAD_YEARS,
  validate: 'one_exact_match',
}
export const OPTIONS_LOAD_YEARS = {
  options: DEFAULT_LOAD_YEARS,
  validate: 'contains_only',
}
// Redlining grade options.
export const OPTIONS_ACTIVE_REDLINING = {
  options: ['A', 'B', 'C', 'D'],
  validate: 'contains_only',
}
// Point feature options.
// Order here goes from highest z-index to lowest (least populous to most).
export const OPTIONS_ACTIVE_POINTS = {
  options: DEFAULT_ACTIVE_POINTS,
  validate: 'contains_only',
}
// all demos in increasing order of average COI
export const DEMOS_BY_COI = ['b', 'ai', 'hi', 'w', 'ap']
export const OPTIONS_RATING_TYPE = {
  options: RATING_TYPES,
  validate: 'one_exact_match',
}
// c: overall (coi)
// e: education (ed)
// h: health (he)
// o: economic (se)
export const OPTIONS_METRIC = {
  options: [COI_METRIC, 'e', 'h', 'o'],
  validate: 'one_exact_match',
}
// national, state, metro
export const OPTIONS_NORM = {
  options: NORM_TYPES,
  validate: 'one_exact_match',
}
// export const OPTIONS_DATA_VERSION = {
//   options: /^([0-9]+).([0-9]+).([0-9]+)?$/g,
//   validate: 'regex', // Create a regex with the supplied option and validate against that.
// }

export const getDefaultRoute = ({
  view = DEFAULT_VIEW,
  geo = DEFAULT_GEO,
  activeShape = DEFAULT_ACTIVE_SHAPE,
  activeYear = DEFAULT_ACTIVE_YEAR,
  loadYears = DEFAULT_LOAD_YEARS,
  activePoints = DEFAULT_ACTIVE_POINTS,
  ratingType = DEFAULT_RATING_TYPE,
  metric = DEFAULT_METRIC,
  norm = DEFAULT_NORM,
  dataVersion = DEFAULT_DATA_VERSION,
  lat = DEFAULT_LAT,
  lng = DEFAULT_LNG,
  zoom = DEFAULT_ZOOM,
  activeRedlining = DEFAULT_ACTIVE_REDLINING,
}) =>
  `#/${view}/${geo}/${activeShape}/${activeYear}/${loadYears}/${activePoints}/${ratingType}/${metric}/${norm}/${dataVersion}/${lat}/${lng}/${zoom}/${activeRedlining}`

// #/tracts/5003960400/15/10,15/ai,ap,b,hi,w/x/c/n/1.0.14/29.671/-91.571/4.8/A,B,C,D
export const DEFAULT_ROUTE = getDefaultRoute({})

const ROUTE_OPTIONS = [
  [ROUTE_VIEW, OPTIONS_VIEW],
  [ROUTE_GEO, OPTIONS_GEO],
  [ROUTE_ACTIVE_SHAPE, OPTIONS_ACTIVE_SHAPE],
  [ROUTE_ACTIVE_YEAR, OPTIONS_ACTIVE_YEAR],
  [ROUTE_LOAD_YEARS, OPTIONS_LOAD_YEARS],
  [ROUTE_ACTIVE_POINTS, OPTIONS_ACTIVE_POINTS],
  [ROUTE_RATING_TYPE, OPTIONS_RATING_TYPE],
  [ROUTE_METRIC, OPTIONS_METRIC],
  [ROUTE_NORM, OPTIONS_NORM],
  // data version is now fixed in the route, not customizable by user
  ['dataVersion', {}],
  // lat, lng, zoom don't have route options of the same form
  [ROUTE_LAT, {}],
  [ROUTE_LNG, {}],
  [ROUTE_ZOOM, {}],
  [ROUTE_ACTIVE_REDLINING, OPTIONS_ACTIVE_REDLINING],
]

export const OPTIONS_MAP = _.fromPairs(
  ROUTE_OPTIONS.filter(o => !!o[1].options),
)
export const ROUTE_SET = ROUTE_OPTIONS.map(
  ([route]) => route,
)

// Data files to load from remote.
export const DATA_FILES = [
  {
    id: 'metros',
    filename: 'metro_names',
    ext: 'json',
    type: 'data',
    yearDependent: 0,
    useInUtils: true,
  },
  {
    id: 'county_names',
    filename: 'county_names',
    ext: 'json',
    type: 'data',
    yearDependent: 0,
    useInUtils: true,
  },
  {
    id: 'poi_data',
    filename: 'poi_data',
    ext: 'json',
    type: 'data',
    yearDependent: 0,
    useInUtils: true,
  },
  {
    id: 'pop',
    filename: 'pop',
    ext: 'csv',
    type: 'data',
    geoDependent: 1,
    yearDependent: 1,
  },
  {
    id: 'raw',
    filename: 'raw',
    ext: 'csv',
    type: 'data',
    geoDependent: 1,
    yearDependent: 1,
    // fixedVersion: { tracts: '4.0.2', counties: '4.0.2' },
  },
  {
    id: 'barcharts',
    filename: 'barcharts',
    ext: 'json',
    type: 'data',
    yearDependent: 0,
  },
  {
    id: 'barcharts_poi',
    filename: 'barcharts/barcharts_poi',
    ext: 'json',
    type: 'data',
    unzipped: true,
    yearDependent: 0,
  },
  {
    id: 'indicatorMap',
    filename: 'indicator_map',
    ext: 'json',
    type: 'data',
    yearDependent: 0,
  },
  {
    id: 'redliningBreakdown',
    filename: 'red_areas',
    ext: 'json',
    type: 'data',
    yearDependent: 0,
  },
]

export const DEFAULT_VIEWPORT = {
  latitude: Number(DEFAULT_LAT),
  longitude: Number(DEFAULT_LNG),
  zoom: Number(DEFAULT_ZOOM),
  maxZoom: 14,
  minZoom: 3,
  bearing: 0,
  pitch: 0,
  dragPan: true,
  touchZoom: true,
  touchRotate: true,
  // preserveDrawingBuffer: true,
  height: '100%', // 800, // '800px', // '100%',
  width: '100%', // 1200, // '1200px', // '100%',
  maxBounds: [
    // [-107.6, 33.8], // southwest.
    [-176, 13.8], // southwest.
    // [-65, 49.9], // northeast.
    [-55, 80], // northeast.
  ],
}

const DEFAULT_POINT_SIZE = 10

export const POINT_TYPES = [
  {
    id: 'ai',
    color: theme.extras.demos.ai,
    size: DEFAULT_POINT_SIZE * 2,
  },
  {
    id: 'ap',
    color: theme.extras.demos.ap,
    size: DEFAULT_POINT_SIZE,
  },
  {
    id: 'hi',
    color: theme.extras.demos.hi,
    size: DEFAULT_POINT_SIZE,
  },
  {
    id: 'b',
    color: theme.extras.demos.b,
    size: DEFAULT_POINT_SIZE,
  },
  {
    id: 'w',
    color: theme.extras.demos.w,
    size: DEFAULT_POINT_SIZE,
  },
]

export const SHAPE_ZOOM_LEVELS = [
  { id: 'tracts', minZoom: 3 },
  { id: 'metros', minZoom: 3 },
  { id: 'states', minZoom: 3 },
]

export const MAP_CONTROLS_CLASSES = [
  'map-legend',
  'mapboxgl-ctrl',
  'block-click',
  'map-notifications',
  'more-controls',
  'map-fly-to-btn',
  'modal-intro-parent',
  'react-autosuggest__suggestions-container',
  'control-panel-share-popper',
]

// Default zoom level for all fly-to actions.
export const FLY_TO_ZOOM = 13

export const STATES_WITHOUT_COUNTY_LEVELS = [10, 11, 15, 44]
export const STATES = {
  1: {
    full: 'Alabama',
    abbr: 'AL',
  },
  2: {
    full: 'Alaska',
    abbr: 'AK',
  },
  4: {
    full: 'Arizona',
    abbr: 'AZ',
  },
  5: {
    full: 'Arkansas',
    abbr: 'AR',
  },
  6: {
    full: 'California',
    abbr: 'CA',
  },
  8: {
    full: 'Colorado',
    abbr: 'CO',
  },
  9: {
    full: 'Connecticut',
    abbr: 'CT',
  },
  10: {
    full: 'Delaware',
    abbr: 'DE',
  },
  11: {
    full: 'District of Columbia',
    abbr: 'DC',
  },
  12: {
    full: 'Florida',
    abbr: 'FL',
  },
  13: {
    full: 'Georgia',
    abbr: 'GA',
  },
  15: {
    full: 'Hawaii',
    abbr: 'HI',
  },
  16: {
    full: 'Idaho',
    abbr: 'ID',
  },
  17: {
    full: 'Illinois',
    abbr: 'IL',
  },
  18: {
    full: 'Indiana',
    abbr: 'IN',
  },
  19: {
    full: 'Iowa',
    abbr: 'IA',
  },
  20: {
    full: 'Kansas',
    abbr: 'KS',
  },
  21: {
    full: 'Kentucky',
    abbr: 'KY',
  },
  22: {
    full: 'Louisiana',
    abbr: 'LA',
  },
  23: {
    full: 'Maine',
    abbr: 'ME',
  },
  24: {
    full: 'Maryland',
    abbr: 'MD',
  },
  25: {
    full: 'Massachusetts',
    abbr: 'MA',
  },
  26: {
    full: 'Michigan',
    abbr: 'MI',
  },
  27: {
    full: 'Minnesota',
    abbr: 'MN',
  },
  28: {
    full: 'Mississippi',
    abbr: 'MS',
  },
  29: {
    full: 'Missouri',
    abbr: 'MO',
  },
  30: {
    full: 'Montana',
    abbr: 'MT',
  },
  31: {
    full: 'Nebraska',
    abbr: 'NE',
  },
  32: {
    full: 'Nevada',
    abbr: 'NV',
  },
  33: {
    full: 'New Hampshire',
    abbr: 'NH',
  },
  34: {
    full: 'New Jersey',
    abbr: 'NJ',
  },
  35: {
    full: 'New Mexico',
    abbr: 'NM',
  },
  36: {
    full: 'New York',
    abbr: 'NY',
  },
  37: {
    full: 'North Carolina',
    abbr: 'NC',
  },
  38: {
    full: 'North Dakota',
    abbr: 'ND',
  },
  39: {
    full: 'Ohio',
    abbr: 'OH',
  },
  40: {
    full: 'Oklahoma',
    abbr: 'OK',
  },
  41: {
    full: 'Oregon',
    abbr: 'OR',
  },
  42: {
    full: 'Pennsylvania',
    abbr: 'PA',
  },
  44: {
    full: 'Rhode Island',
    abbr: 'RI',
  },
  45: {
    full: 'South Carolina',
    abbr: 'SC',
  },
  46: {
    full: 'South Dakota',
    abbr: 'SD',
  },
  47: {
    full: 'Tennessee',
    abbr: 'TN',
  },
  48: {
    full: 'Texas',
    abbr: 'TX',
  },
  49: {
    full: 'Utah',
    abbr: 'UT',
  },
  50: {
    full: 'Vermont',
    abbr: 'VT',
  },
  51: {
    full: 'Virginia',
    abbr: 'VA',
  },
  53: {
    full: 'Washington',
    abbr: 'WA',
  },
  54: {
    full: 'West Virginia',
    abbr: 'WV',
  },
  55: {
    full: 'Wisconsin',
    abbr: 'WI',
  },
  56: {
    full: 'Wyoming',
    abbr: 'WY',
  },
  72: {
    full: 'Puerto Rico',
    abbr: 'PR',
  },
}

export const STATE_BOUNDS_MAP = {
  AL: {
    xmin: -88.473227,
    ymin: 30.223334,
    xmax: -84.88908,
    ymax: 35.008028,
  },
  AK: {
    xmin: -179.148909,
    ymin: 51.214183,
    xmax: -129.77847,
    ymax: 71.365162,
  },
  AZ: {
    xmin: -114.81651,
    ymin: 31.332177,
    xmax: -109.045223,
    ymax: 37.00426,
  },
  AR: {
    xmin: -94.617919,
    ymin: 33.004106,
    xmax: -89.644395,
    ymax: 36.4996,
  },
  CA: {
    xmin: -124.409591,
    ymin: 32.534156,
    xmax: -114.131211,
    ymax: 42.009518,
  },
  CO: {
    xmin: -109.060253,
    ymin: 36.992426,
    xmax: -102.041524,
    ymax: 41.003444,
  },
  CT: {
    xmin: -73.727775,
    ymin: 40.980144,
    xmax: -71.786994,
    ymax: 42.050587,
  },
  DE: {
    xmin: -75.788658,
    ymin: 38.451013,
    xmax: -75.048939,
    ymax: 39.839007,
  },
  DC: {
    xmin: -77.119759,
    ymin: 38.791645,
    xmax: -76.909395,
    ymax: 38.99511,
  },
  FL: {
    xmin: -87.634938,
    ymin: 24.523096,
    xmax: -80.031362,
    ymax: 31.000888,
  },
  GA: {
    xmin: -85.605165,
    ymin: 30.357851,
    xmax: -80.839729,
    ymax: 35.000659,
  },
  HI: {
    xmin: -160.334698,
    ymin: 19.910361,
    xmax: -154.806773,
    ymax: 21.402123,
  },
  ID: {
    xmin: -117.243027,
    ymin: 41.988057,
    xmax: -111.043564,
    ymax: 49.001146,
  },
  IL: {
    xmin: -91.513079,
    ymin: 36.970298,
    xmax: -87.494756,
    ymax: 42.508481,
  },
  IN: {
    xmin: -88.09776,
    ymin: 37.771742,
    xmax: -84.784579,
    ymax: 41.760592,
  },
  IA: {
    xmin: -96.639704,
    ymin: 40.375501,
    xmax: -90.140061,
    ymax: 43.501196,
  },
  KS: {
    xmin: -102.051744,
    ymin: 36.993016,
    xmax: -94.588413,
    ymax: 40.003162,
  },
  KY: {
    xmin: -89.571509,
    ymin: 36.497129,
    xmax: -81.964971,
    ymax: 39.147458,
  },
  LA: {
    xmin: -94.043147,
    ymin: 28.928609,
    xmax: -88.817017,
    ymax: 33.019457,
  },
  ME: {
    xmin: -71.083924,
    ymin: 42.977764,
    xmax: -66.949895,
    ymax: 47.459686,
  },
  MD: {
    xmin: -79.487651,
    ymin: 37.911717,
    xmax: -75.048939,
    ymax: 39.723043,
  },
  MA: {
    xmin: -73.508142,
    ymin: 41.237964,
    xmax: -69.928393,
    ymax: 42.886589,
  },
  MI: {
    xmin: -90.418136,
    ymin: 41.696118,
    xmax: -82.413474,
    ymax: 48.2388,
  },
  MN: {
    xmin: -97.239209,
    ymin: 43.499356,
    xmax: -89.491739,
    ymax: 49.384358,
  },
  MS: {
    xmin: -91.655009,
    ymin: 30.173943,
    xmax: -88.097888,
    ymax: 34.996052,
  },
  MO: {
    xmin: -95.774704,
    ymin: 35.995683,
    xmax: -89.098843,
    ymax: 40.61364,
  },
  MT: {
    xmin: -116.050003,
    ymin: 44.358221,
    xmax: -104.039138,
    ymax: 49.00139,
  },
  NE: {
    xmin: -104.053514,
    ymin: 39.999998,
    xmax: -95.30829,
    ymax: 43.001708,
  },
  NV: {
    xmin: -120.005746,
    ymin: 35.001857,
    xmax: -114.039648,
    ymax: 42.002207,
  },
  NH: {
    xmin: -72.557247,
    ymin: 42.69699,
    xmax: -70.610621,
    ymax: 45.305476,
  },
  NJ: {
    xmin: -75.559614,
    ymin: 38.928519,
    xmax: -73.893979,
    ymax: 41.357423,
  },
  NM: {
    xmin: -109.050173,
    ymin: 31.332301,
    xmax: -103.001964,
    ymax: 37.000232,
  },
  NY: {
    xmin: -79.762152,
    ymin: 40.496103,
    xmax: -71.856214,
    ymax: 45.01585,
  },
  NC: {
    xmin: -84.321869,
    ymin: 33.842316,
    xmax: -75.460621,
    ymax: 36.588117,
  },
  ND: {
    xmin: -104.0489,
    ymin: 45.935054,
    xmax: -96.554507,
    ymax: 49.000574,
  },
  OH: {
    xmin: -84.820159,
    ymin: 38.403202,
    xmax: -80.518693,
    ymax: 41.977523,
  },
  OK: {
    xmin: -103.002565,
    ymin: 33.615833,
    xmax: -94.430662,
    ymax: 37.002206,
  },
  OR: {
    xmin: -124.566244,
    ymin: 41.991794,
    xmax: -116.463504,
    ymax: 46.292035,
  },
  PA: {
    xmin: -80.519891,
    ymin: 39.7198,
    xmax: -74.689516,
    ymax: 42.26986,
  },
  PR: {
    xmin: -67.945404,
    ymin: 17.88328,
    xmax: -65.220703,
    ymax: 18.515683,
  },
  RI: {
    xmin: -71.862772,
    ymin: 41.146339,
    xmax: -71.12057,
    ymax: 42.018798,
  },
  SC: {
    xmin: -83.35391,
    ymin: 32.0346,
    xmax: -78.54203,
    ymax: 35.215402,
  },
  SD: {
    xmin: -104.057698,
    ymin: 42.479635,
    xmax: -96.436589,
    ymax: 45.94545,
  },
  TN: {
    xmin: -90.310298,
    ymin: 34.982972,
    xmax: -81.6469,
    ymax: 36.678118,
  },
  TX: {
    xmin: -106.645646,
    ymin: 25.837377,
    xmax: -93.508292,
    ymax: 36.500704,
  },
  UT: {
    xmin: -114.052962,
    ymin: 36.997968,
    xmax: -109.041058,
    ymax: 42.001567,
  },
  VT: {
    xmin: -73.43774,
    ymin: 42.726853,
    xmax: -71.464555,
    ymax: 45.016659,
  },
  VA: {
    xmin: -83.675395,
    ymin: 36.540738,
    xmax: -75.242266,
    ymax: 39.466012,
  },
  WA: {
    xmin: -124.763068,
    ymin: 45.543541,
    xmax: -116.915989,
    ymax: 49.002494,
  },
  WV: {
    xmin: -82.644739,
    ymin: 37.201483,
    xmax: -77.719519,
    ymax: 40.638801,
  },
  WI: {
    xmin: -92.888114,
    ymin: 42.491983,
    xmax: -86.805415,
    ymax: 47.080621,
  },
  WY: {
    xmin: -111.056888,
    ymin: 40.994746,
    xmax: -104.05216,
    ymax: 45.005904,
  },
}

export const STATE_OPTIONS = Object.keys(STATES)
  .map(f => ({
    value: Number(f),
    display: STATES[f].full,
  }))
  .filter(({ val }) => val !== 72)

// takes an array of state codes and returns  a bbox containing them all
export const getStateBounds = stateCodes => {
  const stateBounds = stateCodes
    .map(code => STATE_BOUNDS_MAP[code])
    .filter(b => !!b)
  if (!stateBounds.length) return null

  return [
    [
      Math.min(...stateBounds.map(({ xmin }) => xmin)),
      Math.min(...stateBounds.map(({ ymin }) => ymin)),
    ],
    [
      Math.max(...stateBounds.map(({ xmax }) => xmax)),
      Math.max(...stateBounds.map(({ ymax }) => ymax)),
    ],
  ]
}

// above this zoom level we provide additional functionality
export const FULL_FUNCT_ZOOM_THRESHOLD = 6.5
// above this zoom level zip and metro boundaries appear
export const BOUNDARIES_ZOOM_THRESHOLD = 5
export const ZIPS_LINE_WIDTH_BUMP_ZOOM_THRESHOLD = 7
